import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { ActivateUserPostRequestModel, ActivateUserPostResponseModel } from "@/features/user/services/user-model";

export class ActivateUserApi {
  /**
   *  利用者登録API
   */
  public postActivateUser = async (
    param: ActivateUserPostRequestModel
  ): Promise<ActivateUserPostResponseModel> => {
    const path = `/api/activate`;

    const res = await ApiClient.instance.post<ActivateUserPostResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
